export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8756.3b32ddb4.jpg";